import { gql } from '@apollo/client';

export const ADD_PERSON_ALERT = gql`
  mutation addPersonAlert($input: AddPersonAlertInput!) {
    addPersonAlert(input: $input) {
     __typename
     personUuid
     personAlertUuid
     personAlert {
      alertType {
        __typename
        id
        name
        alertLevel
        position
        oriId
      }
      expireAt
      id
      notes
      officerId
     }
     clientMutationId
     errors
    }
  }
`